// src/pages/paxTypes/EditPaxTypes.jsx

import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditPaxTypes from "../../components/paxTypes/FormAddEditPaxTypes";
import useGetPaxType from "../../hooks/paxTypes/useGetPaxType";
import { CircularProgress, Box } from "@mui/material";

const EditPaxTypes = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { isLoading, paxType } = useGetPaxType(id);

    if (isLoading) {
        return (
            <WrapperSection>
                <Box display="flex" justifyContent="center" p={4}>
                    <CircularProgress />
                </Box>
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditPaxTypes
                isEdit={true}
                currentData={paxType}
                onSubmitSuccess={() => navigate("/pax-types")}
            />
        </WrapperSection>
    );
};

export default EditPaxTypes;